import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class DocumentInboxService {
  private readonly baseUrl = 'document_inbox';

  constructor(private httpClient: HttpClientService) {}

  index(params: any): Promise<any> {
    return this.httpClient.get(`${this.baseUrl}.json`, params);
  }

  markReviewed(documentId: number): Promise<any> {
    return this.httpClient.put(`${this.baseUrl}/documents/${documentId}/review.json`, {});
  }

  markUnreviewed(documentId: number): Promise<any> {
    return this.httpClient.delete(`${this.baseUrl}/documents/${documentId}/review.json`);
  }

  reviewAndHide(documentId: number): Promise<any> {
    return this.httpClient.put(`${this.baseUrl}/documents/${documentId}/hide.json`, {});
  }

  reviewAll(matterId: number, documentIds: Array<number>): Promise<any> {
    return this.httpClient.put(`${this.baseUrl}/matters/${matterId}/review.json`, { document_ids: documentIds });
  }

  hideAll(matterId: number, documentIds: Array<number>): Promise<any> {
    return this.httpClient.put(`${this.baseUrl}/matters/${matterId}/hide.json`, { document_ids: documentIds });
  }

  unhideAll(matterId: number): Promise<any> {
    return this.httpClient.delete(`${this.baseUrl}/matters/${matterId}/hide.json`);
  }
}
